/** Shared vertical zones for the AWP-300 Advanced Wafer Processing Module. */
export type Awp300Layout = {
  width: number;
  depth: number;
  height: number;
  baseH: number;
  capH: number;
  pillarBottom: number;
  pillarTop: number;
  frameT: number;
  hx: number;
  hz: number;
  colW: number;
  glassBottom: number;
  glassTop: number;
  glassH: number;
  glassY: number;
  chamberY: number;
  chamberR: number;
  rackBottom: number;
  rackTop: number;
  loadDeckY: number;
  loadBankZ: number;
  panelX: number;
  panelY: number;
  panelZ: number;
};

export function resolveAwp300Layout(width: number, height: number, depth: number): Awp300Layout {
  const baseH = height * 0.055;
  const capH = height * 0.075;
  const pillarBottom = baseH;
  const pillarTop = height - capH;
  const frameT = width * 0.028;
  const hx = width * 0.46;
  const hz = depth * 0.46;
  const colW = frameT * 1.95;
  const glassBottom = pillarBottom + frameT * 1.1;
  const glassTop = pillarTop - frameT * 0.8;
  const glassH = glassTop - glassBottom;
  const glassY = glassBottom + glassH * 0.5;
  const chamberY = pillarBottom + (pillarTop - pillarBottom) * 0.52;
  const chamberR = Math.min(width, depth) * 0.19;
  const rackBottom = glassBottom + glassH * 0.12;
  const rackTop = chamberY + chamberR * 0.85;
  const loadDeckY = rackBottom + frameT * 0.4;
  const loadBankZ = depth * 0.38;
  const panelX = hx - colW * 0.55;
  const panelY = pillarBottom + (pillarTop - pillarBottom) * 0.55;
  const panelZ = -depth * 0.44;

  return {
    width,
    depth,
    height,
    baseH,
    capH,
    pillarBottom,
    pillarTop,
    frameT,
    hx,
    hz,
    colW,
    glassBottom,
    glassTop,
    glassH,
    glassY,
    chamberY,
    chamberR,
    rackBottom,
    rackTop,
    loadDeckY,
    loadBankZ,
    panelX,
    panelY,
    panelZ,
  };
}
